import React, { useEffect, useState } from 'react';
import { Search, Calendar, MapPin, FileText } from 'lucide-react';
import { SearchBar } from '@/components/common/SearchBar';
import { useGetEventsQuery } from '@/store/api/eventApi';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { LinearProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function CertificateEventListPage() {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(7);
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetEventsQuery({
    search: debouncedSearch,
    page: page + 1,
    limit: pageSize,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);
  const handleCreateCertificate = (eventId: string) => {
    navigate('/create-certificate', {
      state: { eventId },
    });
  };
  const columns: GridColDef[] = [
    {
      field: 'serial',
      headerName: 'S.No.',
      width: 90,
      sortable: false,
      renderCell: (params) => {
        return params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + page * pageSize;
      },
    },
    {
      field: 'name',
      headerName: 'Event Name',
      flex: 1,
      renderCell: (params) => <p className="text-white font-medium">{params.value}</p>,
    },

    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      renderCell: (params) => (
        <div
          title={params.value}
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '90%',
          }}
        >
          {params.value}
        </div>
      ),
    },
    // {
    //   field: 'place',
    //   headerName: 'Location',
    //   flex: 1,
    // },
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      renderCell: (params) => new Date(params.value).toLocaleDateString(),
    },
    // {
    //   field: 'level',
    //   headerName: 'Level',
    //   flex: 1,
    // },
    { field: 'totalCertificates', headerName: 'Total Certificates', flex: 1 },
    // {
    //   field: 'action',
    //   headerName: 'Action',
    //   width: 180,
    //   renderCell: (params) => (
    //     <button
    //       onClick={() => handleCreateCertificate(params.row._id)}
    //       style={{
    //         background:
    //           'linear-gradient(90deg, rgba(111,114,255,0.4) 0%, rgba(39,200,246,0.4) 100%)',
    //       }}
    //       className=" px-3 py-1 rounded text-white text-sm"
    //     >
    //       Create Certificate
    //     </button>
    //   ),
    // },
  ];
  function CustomLoadingOverlay() {
    return (
      <div style={{ width: '100%' }}>
        <LinearProgress />
      </div>
    );
  }
  return (
    <div className=" bg-[#1F1F1F33] text-white lg:p-4 font-sans">
      <div className="border border-white/10 rounded-2xl overflow-hidden bg-[#0d0d14]">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between px-5 py-4 ">
          <p className="font-22 font-medium  text-white pb-2.5 lg:pb-0">
            Showing{' '}
            <span className=" p-2 rounded-full bg-[#303170] text-white font-18 font-bold mx-1">
              {data?.pagination?.total || 0}
            </span>{' '}
            Event
          </p>

          <div className="relative lg:w-[386px]">
            <SearchBar
              value={search}
              onChange={setSearch}
              placeholder="Search by event Name..."
              className="w-64"
            />
          </div>
        </div>
        <div style={{ height: '500px' }}>
          <DataGrid
            rows={data?.data || []}
            columns={columns}
            getRowId={(row) => row._id}
            rowCount={data?.pagination?.total || 0}
            loading={isLoading}
            paginationMode="server"
            slots={{
              loadingOverlay: CustomLoadingOverlay,
            }}
            paginationModel={{ page, pageSize }}
            onPaginationModelChange={(model) => {
              setPage(model.page);
              setPageSize(model.pageSize);
            }}
            onRowClick={(params) => {
              navigate('/certificates', {
                state: {
                  event: params.row,
                },
              });
            }}
            pageSizeOptions={[5, 10, 20]}
            disableRowSelectionOnClick
            sx={{
              backgroundColor: '#000 !important',
              color: '#fff',

              '& .MuiDataGrid-main': {
                backgroundColor: '#000 !important',
              },
              '& .MuiDataGrid-overlay': {
                background: 'linear-gradient(178.14deg, #000000 1.65%, #6F72FF 180.97%)',
                color: '#fff',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#000 !important',
                color: '#fff !important',
                borderBottom: '1px solid #222',
              },

              '& .MuiDataGrid-columnHeader': {
                backgroundColor: '#000 !important',
              },

              '& .MuiDataGrid-columnHeaderTitle': {
                color: '#fff !important',
                fontWeight: 600,
              },

              '& .MuiDataGrid-row': {
                backgroundColor: '#000 !important',
                borderBottom: '1px solid #111',
              },

              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#111 !important',
              },

              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid #111',
                color: '#fff',
              },

              '& .MuiCheckbox-root': {
                color: '#fff !important',
              },

              '& .MuiTablePagination-root': {
                color: '#fff',
              },

              '& .MuiDataGrid-footerContainer': {
                backgroundColor: '#000 !important',
                borderTop: '1px solid #222',
              },

              border: '1px solid #222',
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default CertificateEventListPage;
